// extracted by css-extract-rspack-plugin
export default {"failed":"StatusIcon-module__failed__D9k5p","passed":"StatusIcon-module__passed__k2Yju","pending":"StatusIcon-module__pending__sFoAj","unknown":"StatusIcon-module__unknown__bcO3I"};